const isBrowser = typeof window !== 'undefined'
const isNode = typeof process !== 'undefined'

module.exports = !isBrowser && isNode
